import { getTestId } from '@airtel/air-design-system';
var breadcrumbWidgetProps = {
  maxDisplayedItems: 4,
  overflowIndex: 2,
  data: [{
    text: 'Parent page',
    disabled: false
  }, {
    text: 'Parent page',
    disabled: false
  }, {
    text: 'Parent page',
    disabled: false
  }, {
    text: 'Parent page',
    disabled: false
  }, {
    text: 'Parent page',
    disabled: false
  }, {
    text: 'Parent page',
    disabled: false
  }],
  onPress: {
    id: 'breadcrum'
  },
  onUserAction: data => {
    console.log(data);
  }
};
export var defaultProps = Object.assign(Object.assign({}, getTestId('NavbarWidgetContainer')), {
  breadcrumbWidgetProps,
  testID: 'NavbarWidgetContainer',
  gridColBreadCrumbsProps: {
    noTopGutter: true
  },
  noMargin: true
});